import { useQueryApi } from 'utils/api'
import { handleError, validateStatus } from 'api/kinerja/penilik-pegawai/config'
import { apiPaths, queryKeys } from './config'

import type { Summary } from 'types/kinerja-tim-penilai-penilik'
import type { UseQueryOptions } from 'react-query'

export function useAPIGetSummary({
  periodId,
  ...options
}: UseQueryOptions<Summary> & { periodId: string }) {
  return useQueryApi<Summary>(apiPaths.summary(periodId), {
    queryKey: [queryKeys.API_GET_SUMMARY, periodId],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: true,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
